import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { CreateUserResponse, CreateUserDto } from '@/types/settings';

export const useCreateUser = createMutationHook<CreateUserResponse, CreateUserDto>({
  mutationFn: (dto) =>
    apiPost<CreateUserResponse, CreateUserDto>(
      operationsClient,
      settingsEndpoints.createUser(),
      dto,
    ),
  onSuccess: (data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.users() });
    // The two-branch backend returns the same payload shape with an extra
    // `invitationSent` flag. We surface the right toast here so the call
    // site only has to navigate — it doesn't need to know which path the
    // server took.
    if (data.invitationSent) {
      toast.success(`Invitation email sent to ${data.email}`);
    } else {
      toast.success('User created');
    }
  },
});
